import { render } from "./face-mesh-view.vue?vue&type=template&id=d87cd344"
import script from "./face-mesh-view.vue?vue&type=script&lang=js"
export * from "./face-mesh-view.vue?vue&type=script&lang=js"

import "./face-mesh-view.vue?vue&type=style&index=0&id=d87cd344&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__